<ng-container *transloco="let t;">
    <div [formGroup]="userProfileForm" class="profile-container">
        <div class="content-header wide-text">
            <h1 class="mb-0">{{ t('Create a profile title text (Onboarding page) - Create a profile') }}
            </h1>
            <p class="subtitle-text">{{ t('Create a profile subtitle text (Onboarding page) - This is how you will
                appear') }}.
            </p>
        </div>
        <div class="profile-image">
            <input type="file" id="profile-image-upload" class="d-none" (change)="onProfileImageUpload($event)"
                accept="image/jpeg,image/png,image/jpg" />
            <button class="profile-image-button" [disabled]="inviteFormDisabled" type="button"
                onclick="document.getElementById('profile-image-upload').click()">
                <ng-container *ngIf="profileImagePreview; else defaultSvg">
                    <img [src]="profileImagePreview" alt="Profile image" class="profile-image-preview" />
                </ng-container>
                <ng-template #defaultSvg>
                    <img class="profile-image-img" width="111" height="111"
                        src="assets/images/pages/onboarding/profile-circle.svg" alt="Profile placeholder" />
                </ng-template>
                <div>
                    <img width="20" height="20" src="assets/images/pages/onboarding/add-profile-image-icon.svg">
                    <span>{{ t('Create a profile add photo text (Onboarding page) - Add a
                        photo') }} </span>
                </div>
            </button>
        </div>
        <div *ngIf="userProfileForm.get('profileImage')?.invalid && userProfileForm.get('profileImage')?.touched">
            <div *ngIf="userProfileForm.get('profileImage')?.errors?.['maxSize'] as error"
                class="invalid-feedback d-block text-center">
                {{ t('onboarding flow image too large error text (onboarding page) - Please
                select a smaller
                image') }}
            </div>
            <div *ngIf="userProfileForm.get('profileImage')?.errors?.['unsupportedFileType']"
                class="invalid-feedback d-block text-center">
                {{ t('onboarding flow image unsupported type error (onboarding page) -
                Profile picture must be a
                png, jpg or jpeg)}}
            </div>
        </div>
        <div class="row custom-row" *ngIf="isInvitedOnboarding">
            <div class="col-6 custom-column-left">
                <label for="firstname" class="form-label onboarding-label-font-size">{{ t('First name (general) - First
                    name') }}</label>
                <input id="firstname" type="text" formControlName="firstName" class="form-control" placeholder="John"
                    aria-describedby="firstname" tabindex="2" />
                <div *ngIf="firstNameControl.invalid && firstNameControl?.touched" class="invalid-feedback"
                    [ngClass]="{ 'd-block': firstNameControl?.invalid && firstNameControl?.touched}">
                    <div *ngIf="firstNameControl?.invalid && firstNameControl?.touched">{{ t("Field required (form
                        validation) - Field name is required",
                        {fieldName: t("First name (general) - First name")}) }}</div>
                </div>
            </div>
            <div class="col-6 custom-column-right">
                <label for="lastname" class="form-label onboarding-label-font-size">{{ t('Last name (general) - Last
                    name') }}</label>
                <input id="lastname" type="text" formControlName="lastName" class="form-control" placeholder="Doe"
                    aria-describedby="lastname" tabindex="3" />
                <div *ngIf="lastNameControl.invalid && lastNameControl?.touched" class="invalid-feedback"
                    [ngClass]="{ 'd-block': lastNameControl?.invalid && lastNameControl?.touched}">
                    <div *ngIf="lastNameControl?.invalid && lastNameControl?.touched">{{ t("Field required (form
                        validation) - Field name is required",
                        {fieldName: t("Last name (general) - Last name")}) }}</div>
                </div>
            </div>
        </div>
        <div class="form-group" *ngIf="isInvitedOnboarding">
            <label for="password" class="form-label onboarding-label-font-size">{{ t('Password - label (general)
                -
                Password') }}</label>

            <div class="input-group input-group-merge form-password-toggle">
                <input [type]="passwordTextType ? 'text' : 'password'" formControlName="password"
                    class="form-control form-control-merge" placeholder="············"
                    aria-describedby="register-password" tabindex="4">
                <div class="input-group-append">
                    <span class="input-group-text cursor-pointer"><i class="feather font-small-4" [ngClass]="{
                                                    'icon-eye-off': passwordTextType,
                                                    'icon-eye': !passwordTextType
                                                  }" (click)="onTogglePasswordTextType()"></i></span>
                </div>
            </div>
            <div *ngIf="passwordControl?.invalid && passwordControl?.touched" class="invalid-feedback"
                [ngClass]="{ 'd-block': passwordControl?.invalid && passwordControl?.touched }">
                <div *ngIf="passwordControl.errors?.required">{{ t('Field required (form
                    validation) - Field name is
                    required', { fieldName: t('Password - label (general) - Password') }) }}</div>
                <div *ngIf="passwordControl.errors?.pattern">{{ t('New Password field validation message (Change
                    password - section)
                    -
                    New
                    Password must contain
                    more than 8 characters 1 numeric 1 upper case letter and 1 special
                    character') }}
                </div>
            </div>
        </div>
        <div class="form-group">
            <label class="form-label onboarding-label-font-size" for="job-title">{{t('job seniority dropdown label on
                onboarding page (Job seniority lable) - Job seniority')}}</label>
            <ng-select id="job-title" name="jobTitle" formControlName="jobTitle" [items]="jobTitleList" bindLabel="name"
                bindValue="name">
            </ng-select>
            <div *ngIf="jobTitleControl?.invalid && jobTitleControl?.touched" class="invalid-feedback"
                [ngClass]="{ 'd-block': jobTitleControl?.invalid && jobTitleControl?.touched}">
                <div *ngIf="jobTitleControl?.invalid && jobTitleControl?.touched">{{ t("Field required (form
                    validation) - Field name is required",
                    {fieldName: t("job seniority dropdown label on onboarding page (Job seniority lable) - Job
                    seniority")}) }}</div>
            </div>
        </div>
        <div class="form-group" *ngIf="!isInvitedOnboarding">
            <label class="form-label onboarding-label-font-size" for="company-name">{{t("Company Name
                (general)
                -
                Company Name")}}</label>
            <input type="text" formControlName="companyName" id="company-name" class="form-control"
                placeholder="e.g., Google" />
            <div *ngIf="companyNameControl?.invalid && companyNameControl?.touched" class="invalid-feedback"
                [ngClass]="{ 'd-block': companyNameControl?.invalid && companyNameControl?.touched}">
                <div *ngIf="companyNameControl?.invalid && companyNameControl?.touched">{{ t("Field required (form
                    validation) - Field name is required",
                    {fieldName: t("Company Name (general) - Company Name")}) }}</div>
            </div>
        </div>
        <div class="form-group">
            <label class="form-label onboarding-label-font-size" for="phone-number">{{t("phone number label (onboarding
                user profile section) - Phone number")}}</label>
            <app-phone-input [formControl]="userProfileForm.get('phone')"
                [isFormSubmitted]="submitted"
                [disabled]="inviteFormDisabled"
                (countrySelected)="onCountrySelected($event)"></app-phone-input>
            <div *ngIf="(userProfileForm.get('phone')?.invalid || userProfileForm.get('phone')?.errors) && userProfileForm.get('phone')?.touched"
                class="invalid-feedback d-block">
                <div *ngIf="userProfileForm.get('phone')?.errors?.required">
                    {{ t("Field required (form validation) - Field name is required", {fieldName: t("Phone (general) - Phone")}) }}
                </div>
                <div *ngIf="userProfileForm.get('phone')?.errors?.validatePhoneNumber?.valid === false">
                    {{ t("Phone number validation for country (form validation) - Please enter a valid phone number for country", {countryName: selectedCountry.name}) }}
                </div>
            </div>
        </div>

        <div class="form-group" *ngIf="isInvitedOnboarding">
            <div class="custom-control custom-checkbox">
                <input class="custom-control-input" type="checkbox" formControlName="terms" id="register-privacy-policy"
                    tabindex="5" />
                <label class="custom-control-label" for="register-privacy-policy">
                    {{ t('Agreement statement part 1 (Register page) - I agree ') }} <a
                        href="javascript:void(0);">{{t('Agreement statement part 2 (Register
                        page) - privacy policy
                        and terms')}}</a>
                </label>
                <div *ngIf="termsControl?.invalid && termsControl?.touched" class="invalid-feedback"
                    [ngClass]="{ 'd-block': termsControl?.invalid && termsControl?.touched}">
                    <div *ngIf="termsControl?.invalid && termsControl?.touched">{{t('Agreement
                        statement
                        validation text (Register page)
                        - You must agree with terms')}}</div>
                </div>
            </div>
        </div>
        <div class="end-page-group-container">
            <div class="justify-content-between continue-button-container child-1">
                <button class="btn btn-primary btn-next btn-submit continue-button" [disabled]="inviteFormDisabled" rippleEffect
                    (click)="onContinueClick()">
                    {{t('Continue button name on onboarding page (continue button name)
                    Continue')}}
                </button>
            </div>


            <div class="wide-text child-2">
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" formControlName="noMarketing" id="no-marketing"
                        tabindex="5" />
                    <label class="custom-control-label" for="no-marketing">
                        {{ t('marketing email checkbox text (Onboarding form) - yes
                        email-spam
                        me')}}
                    </label>
                </div>
            </div>
            <div class="wide-text child-3">
                <small class="description-text">
                    {{t('marketing email can unsubscribe text (Onboarding form) - You can
                    unsubscribe at any
                    time')}}
                </small>
            </div>
        </div>
    </div>
</ng-container>